import React from 'react';

import Chart from 'react-apexcharts';

import { formatPackAxis } from '../../managementPackUtils';
import { box, captionHeight, CONTENT_WIDTH, MARGIN_X } from '../slideGeometry';

import BlockCaption from './BlockCaption';

const TRANSPARENT = 'rgba(0, 0, 0, 0)';

/**
 * A bar chart, a stacked chart with its legend at the top, a stacked bridge whose
 * invisible base series lifts each movement bar to its running total, or a line
 * chart without markers whose `dashed` series are dashed and whose null values
 * are gaps. A caption sits above the plot. Width and height are passed in px: the
 * slide is CSS-scaled, and a chart that measured its own box would be scaled twice.
 */
const ChartBlock = ({ block, thumbnail }) => {
    const series = block.series || [];
    const isLine = block.kind === 'line';
    const isBridge = block.kind === 'stackedBridge';
    const type = isLine ? 'line' : 'bar';
    const isStacked = isBridge || block.kind === 'stacked';
    const top = block.y + captionHeight(block);
    const height = block.height - captionHeight(block);

    if (thumbnail) {
        return <div className="tw-bg-charcoal-10" style={box(MARGIN_X, block.y, CONTENT_WIDTH, block.height)} />;
    }

    const options = {
        chart: {
            fontFamily: 'var(--font-sans)',
            type,
            stacked: isStacked,
            animations: { enabled: false },
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: series.map((item) => (item.invisible ? TRANSPARENT : item.colour || '#055DF5')),
        fill: { opacity: 1 },
        ...(isLine
            ? {
                  stroke: { width: 2, curve: 'straight', dashArray: series.map((item) => (item.dashed ? 6 : 0)) },
                  markers: { size: 0 },
              }
            : {}),
        plotOptions: { bar: { columnWidth: '62%' } },
        dataLabels: { enabled: false },
        tooltip: { enabled: false },
        states: { hover: { filter: { type: 'none' } }, active: { filter: { type: 'none' } } },
        legend: { show: !isBridge && series.length > 1, position: 'top', ...(isLine ? { markers: { width: 12, height: 2 } } : {}) },
        xaxis: { categories: block.categories || [], title: { text: undefined }, axisTicks: { show: false } },
        yaxis: {
            title: { text: undefined },
            ...(block.valueFormat ? { labels: { formatter: (value) => formatPackAxis(value, block.valueFormat.decimals) } } : {}),
        },
        grid: { borderColor: '#E2E2E3' },
    };

    return (
        <>
            <BlockCaption block={block} />
            <div style={box(MARGIN_X, top, CONTENT_WIDTH, height)}>
                <Chart
                    type={type}
                    options={options}
                    series={series.map((item) => ({ name: item.name, data: item.values || [] }))}
                    width={CONTENT_WIDTH}
                    height={height}
                />
            </div>
        </>
    );
};

export default ChartBlock;
